module.exports = __webpack_public_path__ + "img/1f9c6.b2e98cb.svg";